module.exports = function() {
  return new Worker(__webpack_public_path__ + "388d0f743803fe6762d3.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./~/pdfjs-dist/es5/build/pdf.worker.js
// module id = 1712
// module chunks = 1